var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4.04199C0.5 2.109 2.067 0.541992 4 0.541992H28C29.933 0.541992 31.5 2.109 31.5 4.04199V28.042C31.5 29.975 29.933 31.542 28 31.542H4C2.067 31.542 0.5 29.975 0.5 28.042V4.04199Z",
    fill: "white",
    stroke: "#405189"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9069 22.2936H9.09699C8.81382 22.2936 8.57422 22.5332 8.57422 22.8163C8.57422 23.0995 8.81382 23.3391 9.09699 23.3391H22.9069C23.1901 23.3391 23.4297 23.0995 23.4297 22.8163C23.4297 22.5332 23.1901 22.2936 22.9069 22.2936ZM8.596 17.7193L8.57422 20.1807C8.57422 20.3114 8.61778 20.4639 8.72669 20.551C8.83561 20.6381 8.9663 20.7035 9.09699 20.7035L11.5584 20.6817C11.6891 20.6817 11.8198 20.6163 11.9287 20.5292L20.3802 12.0777C20.5762 11.8817 20.5762 11.5332 20.3802 11.3371L17.9406 8.89752C17.7445 8.70148 17.396 8.70148 17.2 8.89752L15.501 10.5965L8.74848 17.349C8.63957 17.4579 8.596 17.5886 8.596 17.7193ZM19.2693 11.7074L18.3109 12.6658L16.6118 10.9668L17.5703 10.0084L19.2693 11.7074ZM9.64155 17.9371L15.8712 11.7074L17.5703 13.4064L11.3406 19.6361H9.64155V17.9371Z",
    fill: "#405189"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.ee923b384518046337f8219c6bb522fa.svg";
export { ForwardRef as ReactComponent };